import { Collapsible } from 'grommet'

export default Collapsible
